module.exports = __webpack_public_path__ + "static/us-logo-f5253f50c951371d76d1dbd70667b3f3.png";